<script lang="tsx">
import { defineComponent, watch, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Timeline } from 'ant-design-vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import { useFetch } from '@/hooks/useFetch'
import { API_JT_PROJ_DETAIL } from '@/api/jtProj'

import StepLaunch from './StepLaunch.vue'
import StepLaunch2 from './StepLaunch2.vue'
import StepReject from './StepReject.vue'
import StepCbmecsResolve from './StepCbmecsResolve.vue'
import StepRymdfhResolve from './StepRymdfhResolve.vue'
import TlDetailField from '../common/TlDetailField.vue'
import CardBox1 from '../../CardBox1.vue'
import GroupAgreementSimpleTable from '../../GroupAgreementSimpleTable.vue'

const [name] = createNamespace('TimelineDetailPensionInsurance')
enum STATUS_TYPE {
  LAUNCH_CBMECS = '发起',
  LAUNCH_RYMDFH = '发起名单复核',
  RE_LAUNCH_CBMECS = '重新发起测算',
  RE_LAUNCH_RYMDFH = '重新发起名单复核',
  CBMECS_RESOLVE = '同意-参保名额测算',
  CBMECS_REJECT = '驳回-参保名额测算',
  RYMDFH_RESOLVE = '同意-人员名单复核',
  RYMDFH_REJECT = '驳回-人员名单复核'
}
export default defineComponent({
  name,
  props: {
    record: {
      type: Object as PropType<any>
    },
    projectId: {
      type: String as PropType<string>
    }
  },
  setup(props) {
    const renderItem = (item: any) => {
      switch (item.type) {
        case STATUS_TYPE.CBMECS_REJECT:
          return <StepReject record={item} />
        case STATUS_TYPE.RYMDFH_REJECT:
          return <StepReject record={item} />
        case STATUS_TYPE.CBMECS_RESOLVE:
          return <StepCbmecsResolve record={item} />
        case STATUS_TYPE.RYMDFH_RESOLVE:
          return <StepRymdfhResolve record={item} />
        case STATUS_TYPE.LAUNCH_RYMDFH:
        case STATUS_TYPE.RE_LAUNCH_RYMDFH:
          return <StepLaunch2 record={item} isRenew={item.type === STATUS_TYPE.RE_LAUNCH_RYMDFH} />
        default:
          return <StepLaunch record={item} isRenew={item.type === STATUS_TYPE.RE_LAUNCH_CBMECS} />
      }
    }
    const { loading, result, fetchData } = useFetch({
      getFn: API_JT_PROJ_DETAIL,
      isShallow: true
    })
    watch(
      () => props.projectId,
      id => {
        if (id) {
          fetchData(id)
        }
      },
      { immediate: true }
    )
    return () => (
      <>
        <div class='mb-32'>
          <CardBox1 title='关联文件' loading={loading.value}>
            <TlDetailField label='规划红线'>
              <FileDisplayNormals files={result.value?.redLineFiles ?? []} colAttrs={{ span: 12 }} />
            </TlDetailField>
            <TlDetailField label='征地批文'>
              <FileDisplayNormals files={result.value?.approvalFiles ?? []} colAttrs={{ span: 12 }} />
            </TlDetailField>
            <TlDetailField label='征收集体土地补偿协议'>
              <GroupAgreementSimpleTable pId={props.projectId} />
            </TlDetailField>
          </CardBox1>
        </div>
        <Timeline>{props.record?.his?.map(renderItem)}</Timeline>
      </>
    )
  }
})
</script>
